export function getDateFrom (date) {
  let m1 = date.getMonth() + 1
  let m2 = m1 < 10 ? '0' + m1 : m1
  let d1 = date.getDate()
  let d2 = d1 < 10 ? '0' + d1 : d1

  return [date.getFullYear(), m2, d2].join('-')
}
